import { Scrambler, showWarning } from "./util.js";
const quickStart = document.getElementById("quickStart");
if (quickStart) {
  // Add enter shortcut
  document.addEventListener("keyup", (e) => {
    if (e.key === "Enter") {
      quickStart.click();
    }
  });

  quickStart.addEventListener("click", async () => {
    // Check if email is filled out
    const email = document.getElementById("email");
    if (!email) return;
    if (!email.value) {
      email.classList.add("is-invalid");
      return showWarning("Please enter your email address");
    }

    const url = "/signup?email=" + encodeURIComponent(email.value);
    window.location.href = url;
  });
}

setTimeout(() => {
  activateScrambler1();
}, 750);

function activateScrambler1() {
  try {
    Scrambler({
      target: "#leadText",
      random: [200, 800],
      speed: 50,
    });
  } catch (err) {
    console.log(err);
  }

  const leadTextAlternative1 = document.getElementById("leadTextAlternative1");
  const leadTextAlternative1Text = leadTextAlternative1.innerText;

  setTimeout(() => {
    try {
      Scrambler({
        target: "#leadText",
        random: [400, 1200],
        speed: 50,
        text: leadTextAlternative1Text,
      });
    } catch (err) {
      console.log(err);
    }
  }, 5000);
}

setTimeout(() => {
  activateScrambler2();
}, 1500);

function activateScrambler2() {
  try {
    Scrambler({
      target: "#leadText2",
      random: [200, 800],
      speed: 50,
    });
  } catch (err) {
    console.log(err);
  }
}

const personaQuote = document.getElementById("personaQuote");
const avatars = document.querySelectorAll(".avatar");

avatars.forEach((avatar) => {
  avatar.addEventListener("click", () => {
    const persona = avatar.getAttribute("data-persona");
    personaQuote.innerHTML = persona;
  });
});
